// import { dataStatistics } from '@/api/dataV'
// import { getToken, setToken, removeToken } from '@/utils/auth'
const state = {
  TimingAlarm: [],
  urgencyShow: true

}

const mutations = {
  setTimingAlarm(state, TimingAlarm) {
    state.TimingAlarm = TimingAlarm
  }
}

const actions = {

}

export default {
  state,
  mutations,
  actions
}
